<div id="container" class="global-search-stickycomponent">
    @if (isEnabled) {
        <div [ngClass]="wrapperClass" (click)="launchSearch()" id="item">
            <a class="fab-search-container">
                @if (canDisplayIcon) {
                    <span [ngClass]="iconClass"></span>
                }
                <!-- ICONS PLACEHOLDER class for the icon "theme-search" to be configured via sitecore -->
                <!-- OR we want to have both options icon or image -->
                @if (canDisplayImage) {
                    <img [src]="imageSource" alt="" class="fab-search-img" />
                }
                <!-- IMAGE PLACEHOLDER src to come from Sitecore, optional additional class from sitecore-->
            </a>
        </div>
    }
</div>
